module.exports = __webpack_public_path__ + "img/AU.2618129e.jpg";